<template>
  <a
    :href="destination"
    class="is-flex is-align-items-center is-flex-wrap-wrap"
    :target="targetNewTab ? '_blank' : null"
    @click="(ev) => onClick(ev)"
  >
    {{ recipe.name }}

    <span v-if="recipe.subrecipe" class="chip is-warning is-light">Subrecipe</span>
    <span v-if="recipe.archived" class="chip archived-chip">Archived</span>
    <WrapWithHint v-if="recipe.empty" tag="span" content="This recipe has no ingredients">
      <span class="chip blank-chip">Blank</span>
    </WrapWithHint>
  </a>
</template>

<script setup>import { computed as _computed } from 'vue';

  import { editRecipePath } from "routes";
  import WrapWithHint from "./wrap-with-hint.vue";

  const props = defineProps({
    recipe: { type: Object, required: true },
    link: { type: Boolean, default: true },
    targetNewTab: { type: Boolean, default: false },
  });

  const emit = defineEmits(["recipe-click"]);

  const onClick = (ev) => {
    if (!props.link) {
      ev.preventDefault();
    }
    emit("recipe-click", props.recipe);
  };

  const destination = _computed(() => {
    return props.link ? editRecipePath(props.recipe.id) : null;
  });
</script>
